import lodash from "lodash";

type ApplicationPermissionsDefinition = {
  code: string;
  name: string;
  description: string;
  url: string;
  icon: string;
  iconForeground: string;
  iconBackground: string;
  sections: Array<{
    name: string;
    value: string;
    permissions: Array<{
      name: string;
      value: string;
    }>;
  }>;
};

export const Applications: ApplicationPermissionsDefinition[] = [
  {
    code: "management",
    name: "Management Console",
    description:
      "The Business Analytics console provides District Managers  of the Electricity Company of Ghana with statistics and insights on the daily or  periodic engagements between their districts and customers. It allows them to monitor all operations within the various departments of the district.",
    url: "https://management.ecg.com.gh",
    icon: "ChartPieIcon",
    iconForeground: "#1D4076",
    iconBackground: "#DAF0FA",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "Create Ticket", value: "service-points:create-ticket" },
          { name: "Initiate Disconnection", value: "service-points:suspend" },
          { name: "Initiate Termination", value: "service-points:terminate" },
          { name: "Restore", value: "service-points:restore" },
          { name: "Update Identity", value: "service-points:update-identity" },
          { name: "Update Contact", value: "service-points:update-contact" },
          { name: "Update Tariff", value: "service-points:update-tariff" },
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
          {
            name: "Update Attributes",
            value: "service-points:update-attributes",
          },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Approve Request", value: "service-requests:approve" },
          { name: "Sign Contract", value: "service-requests:sign-contract" },
          { name: "Update Contact", value: "service-requests:update-contact" },
        ],
      },
      {
        name: "Service Point Reactivations",
        value: "service-point-reactivations:manage",
        permissions: [
          {
            name: "Initiate Reactivations",
            value: "service-point-reactivations:initiate",
          },
        ],
      },
      {
        name: "Reconnection Service Orders",
        value: "reconnection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Disconnection Service Orders",
        value: "disconnection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Fault Service Orders",
        value: "fault-service-orders:manage",
        permissions: [],
      },
      {
        name: "Prepaid Monitoring Service Orders",
        value: "prepaid-monitoring-service-orders:manage",
        permissions: [],
      },
      {
        name: "Disconnection Monitoring Service Orders",
        value: "disconnection-monitoring-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "disconnection-monitoring-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "disconnection-monitoring-service-orders:approve",
          },
          {
            name: "Cancel Order",
            value: "disconnection-monitoring-service-orders:cancel",
          },
          {
            name: "Initiate Disconnection Monitoring",
            value: "disconnection-monitoring-service-orders:initiate",
          },
        ],
      },
      {
        name: "Pending Disconnection Monitoring",
        value: "pending-disconnection-monitoring:manage",
        permissions: [
          {
            name: "Initiate Disconnection Monitoring",
            value: "pending-disconnection-monitoring:initiate-monitoring",
          },
        ],
      },
      {
        name: "Pending Terminations",
        value: "pending-terminations:manage",
        permissions: [
          {
            name: "Initiate Termination Monitoring",
            value: "pending-terminations:initiate-termination",
          },
        ],
      },
      {
        name: "Inspection Service Orders",
        value: "inspection-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "inspection-service-orders:assign" },
          { name: "Approve Order", value: "inspection-service-orders:approve" },
          { name: "Reset Order", value: "inspection-service-orders:reset" },
        ],
      },
      {
        name: "Installation Service Orders",
        value: "installation-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "installation-service-orders:assign" },
          {
            name: "Approve Order",
            value: "installation-service-orders:approve",
          },
          {
            name: "Escalate Order",
            value: "installation-service-orders:escalate",
          },
          { name: "Reset Order", value: "installation-service-orders:reset" },
        ],
      },
      {
        name: "Meter Removal Service Orders",
        value: "termination-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "termination-service-orders:assign" },
          {
            name: "Approve Order",
            value: "termination-service-orders:approve",
          },
          { name: "Cancel Order", value: "termination-service-orders:cancel" },
          {
            name: "Disapprove Order",
            value: "termination-service-orders:disapprove",
          },
        ],
      },
      {
        name: "Prepaid Replacements",
        value: "replacement-service-orders:manage",
        permissions: [
          {
            name: "Submit Final Balance",
            value: "replacement-service-orders:submit-final-balance",
          },
          {
            name: "Initiate Order",
            value: "replacement-service-orders:initiate",
          },
          { name: "Assign Order", value: "replacement-service-orders:assign" },
          {
            name: "Approve Order",
            value: "replacement-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "replacement-service-orders:disapprove",
          },
          { name: "Cancel Order", value: "replacement-service-orders:cancel" },
          { name: "Reset Order", value: "replacement-service-orders:reset" },
        ],
      },
      {
        name: "Investigation Service Orders",
        value: "investigation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "investigation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "investigation-service-orders:approve",
          },
          {
            name: "Assign Order",
            value: "investigation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "investigation-service-orders:approve",
          },
          { name: "Reset Order", value: "investigation-service-orders:reset" },
        ],
      },
      {
        name: "Plots",
        value: "plots:manage",
        permissions: [
          { name: "Create Plot", value: "plots:create" },
          { name: "Update Plot", value: "plots:update" },
          { name: "Lock Plot", value: "plots:lock" },
          { name: "Unlock Plot", value: "plots:unlock" },
        ],
      },
      {
        name: "Readings",
        value: "readings:manage",
        permissions: [
          { name: "Submit Reading", value: "readings:submit" },
          { name: "Upload Reading", value: "readings:upload" },
          { name: "Approve Reading", value: "readings:approve" },
          { name: "Disapprove Reading", value: "readings:disapprove" },
        ],
      },
      {
        name: "Waivers",
        value: "waivers:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [
          { name: "Create Regularization", value: "regularizations:create" },
          { name: "Import Regularization", value: "regularizations:import" },
          { name: "Assign Location", value: "regularizations:assign-location" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [
          {
            name: "Assign Location",
            value: "shep-regularizations:assign-location",
          },
        ],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
          { name: "Reassign Ticket", value: "complaints:reassign" },
          {
            name: "Initiate Investigation",
            value: "complaints:initiate-investigation",
          },
          {
            name: "Initiate Disconnection",
            value: "complaints:initiate-disconnection",
          },
          {
            name: "Initiate Reconnection",
            value: "complaints:initiate-reconnection",
          },
          {
            name: "Initiate Termination",
            value: "complaints:initiate-termination",
          },
          { name: "Initiate Fault", value: "complaints:initiate-fault" },
          {
            name: "Initiate Replacement",
            value: "complaints:initiate-replacement",
          },
          {
            name: "Initiate Transformer Maintenance",
            value: "complaints:initiate-transformer-maintenance",
          },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
      {
        name: "District Target Revenue",
        value: "district-target-revenue:manage",
        permissions: [
          {
            name: "Update District Revenue Target ",
            value: "district-target-revenue:update",
          },
        ],
      },
      {
        name: "Demand Notices",
        value: "demand-notices:manage",
        permissions: [
          {
            name: "Issue Demand Notice",
            value: "demand-notices:issue",
          },
          {
            name: "Reject Demand Notice",
            value: "demand-notices:reject",
          },
        ],
      },
    ],
  },
  {
    code: "debt",
    name: "Debt Management Console",
    description: "Add description here",
    url: "https://debt.ecg.com.gh",
    icon: "CreditCardIcon",
    iconForeground: "#B77F00",
    iconBackground: "#FFF7CC",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "Create Ticket", value: "service-points:create-ticket" },
          { name: "Update Contact", value: "service-points:update-contact" },
          { name: "Initiate Reconnection", value: "service-points:restore" },
          { name: "Initiate Disconnection", value: "service-points:suspend" },
          { name: "Initiate Termination", value: "service-points:terminate" },
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
          {
            name: "Update Attributes",
            value: "service-points:update-attributes",
          },
        ],
      },
      {
        name: "Disconnection Service Orders",
        value: "disconnection-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "disconnection-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "disconnection-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "disconnection-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "disconnection-service-orders:cancel",
          },
        ],
      },
      {
        name: "Disconnection Monitoring Service Orders",
        value: "disconnection-monitoring-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "disconnection-monitoring-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "disconnection-monitoring-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "disconnection-monitoring-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "disconnection-monitoring-service-orders:cancel",
          },
          {
            name: "Initiate Disconnection Monitoring",
            value: "disconnection-monitoring-service-orders:initiate",
          },
        ],
      },
      {
        name: "Pending Disconnection Monitoring",
        value: "pending-disconnection-monitoring:manage",
        permissions: [
          {
            name: "Initiate Disconnection Monitoring",
            value: "pending-disconnection-monitoring:initiate-monitoring",
          },
        ],
      },
      {
        name: "Pending Terminations",
        value: "pending-terminations:manage",
        permissions: [
          {
            name: "Initiate Termination Monitoring",
            value: "pending-terminations:initiate-termination",
          },
        ],
      },
      {
        name: "Reconnection Service Orders",
        value: "reconnection-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "reconnection-service-orders:assign" },
          {
            name: "Approve Order",
            value: "reconnection-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "reconnection-service-orders:disapprove",
          },
          { name: "Cancel Order", value: "reconnection-service-orders:cancel" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
          {
            name: "Initiate Investigation",
            value: "complaints:initiate-investigation",
          },
          {
            name: "Initiate Disconnection",
            value: "complaints:initiate-disconnection",
          },
          {
            name: "Initiate Reconnection",
            value: "complaints:initiate-reconnection",
          },
          {
            name: "Initiate Termination",
            value: "complaints:initiate-termination",
          },
        ],
      },
      {
        name: "Prepaid Replacements",
        value: "replacement-service-orders:manage",
        permissions: [
          {
            name: "Submit Final Balance",
            value: "replacement-service-orders:submit-final-balance",
          },

          { name: "Reset Order", value: "replacement-service-orders:reset" },
        ],
      },
      {
        name: "Postpaid Replacement",
        value: "replacement-service-orders:manage",
        permissions: [],
      },
      {
        name: "Final Balances",
        value: "final-balances:manage",
        permissions: [],
      },
      {
        name: "Debts",
        value: "debts:manage",
        permissions: [
          { name: "Initiate Debt", value: "debts:initiate" },
          { name: "Schedule Debt", value: "debts:schedule" },
          { name: "Cancel Debt", value: "debts:cancel" },
        ],
      },
      {
        name: "Debtor Sets",
        value: "debtor-sets:manage",
        permissions: [
          {
            name: "Assign Disconnector",
            value: "debtor-sets:assign-disconnector",
          },
        ],
      },
      {
        name: "Top Debtors",
        value: "top-debtors:manage",
        permissions: [
          { name: "Assign Team", value: "top-debtors:assign-team" },
          { name: "Set Priority", value: "top-debtors:set-priority" },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
      {
        name: "MDA Assignments",
        value: "mda-assignments:manage",
        permissions: [
          {
            name: "Initiate MDA Assignment",
            value: "mda-assignments:initiate",
          },
        ],
      },
      {
        name: "Demand Notices",
        value: "demand-notices:manage",
        permissions: [
          {
            name: "Issue Demand Notice",
            value: "demand-notices:issue",
          },
          {
            name: "Reject Demand Notice",
            value: "demand-notices:reject",
          },
        ],
      },
      {
        name: "Terminated Debtors",
        value: "terminated-debtors:manage",
        permissions: [],
      },
      {
        name: "Recovery Service Orders",
        value: "recovery-service-orders:manage",
        permissions: [
          {
            name: "Initiate Recovery Service Order",
            value: "recovery-service-orders:initiate",
          },
          {
            name: "Assign Recovery Service Order",
            value: "recovery-service-orders:assign",
          },
          {
            name: "Approve Recovery Service Order",
            value: "recovery-service-orders:approve",
          },
          {
            name: "Disapprove Recovery Service Order",
            value: "recovery-service-orders:disapprove",
          },
        ],
      },
    ],
  },
  {
    code: "commercial",
    name: "Commercial Services Console",
    description:
      "The Commercial Services portal serves as the central system for Customer Relations Executives and their assistants to oversee and handle customer interactions.",
    url: "https://commercial.ecg.com.gh",
    icon: "UsersIcon",
    iconForeground: "#1D4076",
    iconBackground: "#DAF0FA",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "Create Ticket", value: "service-points:create-ticket" },
          { name: "Update Contact", value: "service-points:update-contact" },
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Create Request", value: "service-requests:create" },
          { name: "Approve Request", value: "service-requests:approve" },
          { name: "Sign Contract", value: "service-requests:sign-contract" },
          {
            name: "Create Net Metering Request",
            value: "service-requests:create-net-meter-request",
          },
        ],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
          {
            name: "Initiate Replacement",
            value: "complaints:initiate-replacement",
          },
          {
            name: "Initiate Investigation",
            value: "complaints:initiate-investigation",
          },
          { name: "Initiate Fault", value: "complaints:initiate-fault" },
          {
            name: "Initiate Disconnection",
            value: "complaints:initiate-disconnection",
          },
          {
            name: "Initiate Reconnection",
            value: "complaints:initiate-reconnection",
          },
          {
            name: "Initiate Termination",
            value: "complaints:initiate-termination",
          },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Surveys",
        value: "customer-surveys:manage",
        permissions: [
          { name: "Create Survey", value: "customer-surveys:create" },
          { name: "Update Survey", value: "customer-surveys:update" },
          { name: "Publish Survey", value: "customer-surveys:publish" },
          { name: "Delete Survey", value: "customer-surveys:delete" },
        ],
      },
      {
        name: "Data Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
    ],
  },
  {
    code: "slt",
    name: "SLT Services Console",
    description:
      "The SLT Services portal serves as the central system for Customer Relations Executives and their assistants to oversee and handle customer interactions.",
    url: "https://slt.ecg.com.gh",
    icon: "UserGroupIcon",
    iconForeground: "#275745",
    iconBackground: "#E6F8E7",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "Create Ticket", value: "service-points:create-ticket" },
          { name: "Update Contact", value: "service-points:update-contact" },
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
          {
            name: "Update Attributes",
            value: "service-points:update-attributes",
          },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Create Request", value: "service-requests:create" },
          { name: "Approve Request", value: "service-requests:approve" },
          { name: "Sign Contract", value: "service-requests:sign-contract" },
          {
            name: "Resolve Pre-Installation Survey",
            value: "service-requests:resolve-inspection",
          },
          {
            name: "Resolve Installation",
            value: "service-requests:resolve-installation",
          },
        ],
      },
      {
        name: "Installation Service Orders",
        value: "installation-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "installation-service-orders:assign" },
          {
            name: "De-escalate Order",
            value: "installation-service-orders:de-escalate",
          },
          {
            name: "Approve Order",
            value: "installation-service-orders:approve",
          },
          { name: "Reset Order", value: "installation-service-orders:reset" },
        ],
      },
      {
        name: "Replacement Service Orders",
        value: "replacement-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "replacement-service-orders:initiate",
          },
          { name: "Cancel Order", value: "replacement-service-orders:cancel" },
          { name: "Assign Order", value: "replacement-service-orders:assign" },
          {
            name: "Approve Order",
            value: "replacement-service-orders:approve",
          },
          { name: "Reset Order", value: "replacement-service-orders:reset" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "identity",
    name: "Identity Management Console",
    description:
      "The Identity Management portal acts as a centralized hub for overseeing user access and enhancing security. It facilitates the configuration of user profiles for distinct Electricity Company of Ghana (ECG) consoles.",
    url: "https://identity.ecg.com.gh",
    icon: "UserCircleIcon",
    iconForeground: "#202438",
    iconBackground: "#EDEFF6",
    sections: [
      {
        name: "Access Logs",
        value: "access-logs:manage",
        permissions: [],
      },
      {
        name: "Activity Logs",
        value: "activity-logs:manage",
        permissions: [],
      },
      {
        name: "Users",
        value: "users:manage",
        permissions: [
          { name: "Create User", value: "users:create" },
          { name: "Update User", value: "users:update" },
          { name: "Unblock User", value: "users:enable" },
          { name: "Block User", value: "users:disable" },
          { name: "Reset Fingerprint", value: "users:reset-fingerprint" },
          { name: "Nominate User", value: "users:nominate" },
          { name: "Denominate User", value: "users:denominate" },
        ],
      },
      {
        name: "User Roles",
        value: "user-roles:manage",
        permissions: [
          { name: "Create Role", value: "user-roles:create" },
          { name: "Update Role", value: "user-roles:update" },
          { name: "Disable Role", value: "user-roles:disable" },
          { name: "Enable Role", value: "user-roles:enable" },
        ],
      },
      {
        name: "User Teams",
        value: "user-teams:manage",
        permissions: [
          { name: "Create Team", value: "user-teams:create" },
          { name: "Update Team", value: "user-teams:update" },
        ],
      },

      {
        name: "Contractors",
        value: "contractors:manage",
        permissions: [
          { name: "Create Contractor", value: "contractors:create" },
          { name: "Update Contractor", value: "contractors:update" },
          { name: "Enable Contractor", value: "contractors:enable" },
          { name: "Disable Contractor", value: "contractors:disable" },
        ],
      },
      {
        name: "Contractor Users",
        value: "contractors:manage",
        permissions: [
          { name: "Create Agent", value: "contractor-users:create" },
          { name: "Update Agent", value: "contractor-users:update" },
          { name: "Unblock Agent", value: "contractor-users:enable" },
          { name: "Block Agent", value: "contractor-users:disable" },
          {
            name: "Reset Agent Fingerprint",
            value: "contractor-users:reset-fingerprint",
          },
        ],
      },
      {
        name: "Meter Contractors",
        value: "meter-contractors:manage",
        permissions: [
          { name: "Create Contractor", value: "meter-contractors:create" },
          { name: "Update Contractor", value: "meter-contractors:update" },
          { name: "Enable Contractor", value: "meter-contractors:enable" },
          { name: "Disable Contractor", value: "meter-contractors:disable" },
        ],
      },
      {
        name: "Meter Contractor Users",
        value: "meter-contractor-users:manage",
        permissions: [
          { name: "Create Agent", value: "meter-contractor-users:create" },
          { name: "Update Agent", value: "meter-contractor-users:update" },
          { name: "Unblock Agent", value: "meter-contractor-users:enable" },
          { name: "Block Agent", value: "meter-contractor-users:disable" },
          {
            name: "Reset Agent Fingerprint",
            value: "meter-contractor-users:reset-fingerprint",
          },
        ],
      },
      {
        name: "Partners",
        value: "partners:manage",
        permissions: [
          { name: "Create Partner", value: "partners:create" },
          { name: "Update Partner", value: "partners:update" },
          { name: "Delete Contractor", value: "partners:delete" },
        ],
      },
      {
        name: "Partner Users",
        value: "partner-users:manage",
        permissions: [
          { name: "Create Partner User", value: "partner-users:create" },
          { name: "Update Partner User", value: "partner-users:update" },
          { name: "Unblock Partner User", value: "partner-users:enable" },
          { name: "Block Partner User", value: "partner-users:disable" },
          {
            name: "Reset Partner User Fingerprint",
            value: "partner-users:reset-fingerprint",
          },
        ],
      },
      {
        name: "Tariff Classes",
        value: "tariff-classes:manage",
        permissions: [
          { name: "Create Tariff Class", value: "tariff-classes:create" },
          { name: "Update Tariff Class", value: "tariff-classes:update" },
          { name: "Configure Tariff Class", value: "tariff-instances:create" },
        ],
      },
      {
        name: "Complaint Types",
        value: "complaint-types:manage",
        permissions: [
          { name: "Create Complaint Type", value: "complaint-types:create" },
          { name: "Update Complaint Type", value: "complaint-types:update" },
        ],
      },
      {
        name: "Enquiry Types",
        value: "enquiry-types:manage",
        permissions: [
          { name: "Create Enquiry Type", value: "enquiry-types:create" },
          { name: "Update Enquiry Type", value: "enquiry-types:update" },
        ],
      },
      {
        name: "Ministry",
        value: "ministries:manage",
        permissions: [
          { name: "Create Ministry", value: "ministries:create" },
          { name: "Update Ministry", value: "ministries:update" },
          { name: "Delete Ministry", value: "ministries:delete" },
          { name: "Enable Ministry", value: "ministries:enable" },
          { name: "Disable Ministry", value: "ministries:disable" },
        ],
      },
      {
        name: "Ministries Departments and Agencies",
        value: "mdas:manage",
        permissions: [
          {
            name: "Create Ministry Department And Agency",
            value: "mdas:create",
          },
          {
            name: "Update Ministry Department And Agency",
            value: "mdas:update",
          },
          {
            name: "Delete Ministry Department And Agency",
            value: "mdas:delete",
          },
          {
            name: "Enable Ministry Department And Agency",
            value: "mdas:enable",
          },
          {
            name: "Disable Ministry Department And Agency",
            value: "mdas:disable",
          },
        ],
      },
      {
        name: "Appliances",
        value: "appliances:manage",
        permissions: [
          { name: "Create Appliance", value: "appliances:create" },
          { name: "Update Appliance", value: "appliances:update" },
          { name: "Delete Appliance", value: "appliances:delete" },
        ],
      },
      {
        name: "Solar PV Components",
        value: "solar-pv-components:manage",
        permissions: [
          { name: "Create Solar PV Component", value: "solar-pv-components:create" },
          { name: "Update Solar PV Component", value: "solar-pv-components:update" },
          { name: "Delete Solar PV Component", value: "solar-pv-components:delete" },
        ],
      },
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
    ],
  },
  {
    code: "prepaid",
    name: "Prepaid Monitoring Console",
    description:
      "The Prepaid Monitoring portal acts as a centralized hub for overseeing user access and enhancing security. It facilitates the configuration of user profiles for distinct Electricity Company of Ghana (ECG) consoles.",
    url: "https://prepaid.ecg.com.gh",
    icon: "BoltIcon",
    iconForeground: "#0D6F0C",
    iconBackground: "#E3FACF",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Meter Check",
        value: "meter-check:manage",
        permissions: [],
      },
      {
        name: "Prepaid Systems",
        value: "prepaid-systems:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "billing",
    name: "Spot Bills Console",
    description:
      "The Spot Bills portal serves as the central command center for District Commercial Officers and their assistants. It empowers them to efficiently oversee various tasks, including  meter reading management, anomaly resolution, disconnections, reconnections, debt management, exception handling, and real-time monitoring of meter reader activities.",
    url: "https://spot-billing.ecg.com.gh",
    icon: "BanknotesIcon",
    iconForeground: "#1238A9",
    iconBackground: "#D3E6FE",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "Create Ticket", value: "service-points:create-ticket" },
          { name: "Update Contact", value: "service-points:update-contact" },
          { name: "Initiate Reconnection", value: "service-points:restore" },
          { name: "Initiate Disconnection", value: "service-points:suspend" },
          { name: "Initiate Termination", value: "service-points:terminate" },
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
          {
            name: "Update Attributes",
            value: "service-points:update-attributes",
          },
          { name: "Record Bill", value: "service-points:migrate-balance" },
        ],
      },
      {
        name: "MDA Assignments",
        value: "mda-assignments:manage",
        permissions: [
          {
            name: "Initiate MDA Assignment",
            value: "mda-assignments:initiate",
          },
        ],
      },
      {
        name: "Readings",
        value: "readings:manage",
        permissions: [
          { name: "Submit Reading", value: "readings:submit" },
          { name: "Approve Reading", value: "readings:approve" },
          { name: "Correct Reading", value: "readings:correct" },
          { name: "Disapprove Reading", value: "readings:disapprove" },
          { name: "Investigate Reading", value: "readings:investigate" },
        ],
      },
      {
        name: "Reading Sets",
        value: "reading-sets:manage",
        permissions: [{ name: "Assign Reader", value: "reading-sets:assign" }],
      },
      {
        name: "Reading Exceptions",
        value: "reading-exceptions:manage",
        permissions: [
          { name: "Approve Exception", value: "reading-exceptions:approve" },
          { name: "Disapprove Exception", value: "readings:reject" }, // use what's already there
          { name: "Correct Exception", value: "reading-exceptions:correct" },
          {
            name: "Investigate Exception",
            value: "reading-exceptions:investigate",
          },
        ],
      },
      {
        name: "Reading Anomalies",
        value: "reading-anomalies:manage",
        permissions: [],
      },
      {
        name: "No Trace Readings",
        value: "reading-no-traces:manage",
        permissions: [],
      },
      {
        name: "Disconnection Service Orders",
        value: "disconnection-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "disconnection-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "disconnection-service-orders:approve",
          },
          {
            name: "Cancel Order",
            value: "disconnection-service-orders:cancel",
          },
        ],
      },
      {
        name: "Reconnection Service Orders",
        value: "reconnection-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "reconnection-service-orders:assign" },
          {
            name: "Approve Order",
            value: "reconnection-service-orders:approve",
          },
          { name: "Cancel Order", value: "reconnection-service-orders:cancel" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
          {
            name: "Initiate Investigation",
            value: "complaints:initiate-investigation",
          },
          {
            name: "Initiate Disconnection",
            value: "complaints:initiate-disconnection",
          },
          {
            name: "Initiate Reconnection",
            value: "complaints:initiate-reconnection",
          },
          {
            name: "Initiate Termination",
            value: "complaints:initiate-termination",
          },
        ],
      },
      {
        name: "No Trace Service Orders",
        value: "no-trace-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "no-trace-service-orders:initiate",
          },
          {
            name: "Assign Order",
            value: "no-trace-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "no-trace-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "no-trace-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "no-trace-service-orders:cancel",
          },
          {
            name: "Reset Order",
            value: "no-trace-service-orders:reset",
          },
        ],
      },
      {
        name: "Billing Cycles",
        value: "billing-cycles:manage",
        permissions: [
          {
            name: "Upload Readings",
            value: "billing-cycles:create-reading-set",
          },
          {
            name: "Issue Bill",
            value: "billing-cycles:issue-bill",
          },
          {
            name: "Correct Bill",
            value: "billing-cycles:correct-bill",
          },
          {
            name: "Reject Bill",
            value: "billing-cycles:reject-bill",
          },
          {
            name: "Publish Bills",
            value: "billing-cycles:publish-bills",
          },
        ],
      },
      {
        name: "Inconsistent Reading Service Orders",
        value: "inconsistent-reading-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "inconsistent-reading-service-orders:initiate",
          },
          {
            name: "Assign Order",
            value: "inconsistent-reading-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "inconsistent-reading-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "inconsistent-reading-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "inconsistent-reading-service-orders:cancel",
          },
          {
            name: "Reset Order",
            value: "inconsistent-reading-service-orders:reset",
          },
        ],
      },
      {
        name: "Customer Identification Service Orders",
        value: "customer-identification-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "customer-identification-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "customer-identification-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "customer-identification-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "customer-identification-service-orders:cancel",
          },
          {
            name: "Initiate Order",
            value: "customer-identification-service-orders:initiate",
          },
        ],
      },
      {
        name: "Postpaid Replacements",
        value: "replacement-service-orders:manage",
        permissions: [
          {
            name: "Submit Final Reading",
            value: "replacement-service-orders:submit-final-reading",
          },
        ],
      },
      {
        name: "Exemption Groups",
        value: "exemption-groups:manage",
        permissions: [
          {
            name: "Create Exemption Group",
            value: "exemption-groups:create",
          },
          {
            name: "Update Exemption Group",
            value: "exemption-groups:update",
          },
          {
            name: "Add Service Point to Exemption Group",
            value: "exemption-groups:add",
          },
          {
            name: "Remove Service Point from Exemption Group",
            value: "exemption-groups:remove",
          },
        ],
      },
      {
        name: "Account Groups",
        value: "account-groups:manage",
        permissions: [
          {
            name: "Create Account Group",
            value: "account-groups:create",
          },
          {
            name: "Update Account Group",
            value: "account-groups:update",
          },
          {
            name: "Add Service Point to Account Group",
            value: "account-groups:add",
          },
          {
            name: "Remove Service Point from Account Group",
            value: "account-groups:remove",
          },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
    ],
  },
  {
    code: "mapping",
    name: "Mapping Console",
    description:
      "The mapping portal primarily serves the purpose of assigning geocodes to new customers as they are acquired and making revisions to geocodes for customers who are already in the system.",
    url: "https://mapping.ecg.com.gh",
    icon: "MapIcon",
    iconForeground: "#0C4336",
    iconBackground: "#D2F6D7",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Regions",
        value: "regions:manage",
        permissions: [
          { name: "Create Region", value: "regions:create" },
          { name: "Update Region", value: "regions:update" },
        ],
      },
      {
        name: "Districts",
        value: "districts:manage",
        permissions: [
          { name: "Create District", value: "districts:create" },
          { name: "Update District", value: "districts:update" },
        ],
      },
      {
        name: "Blocks",
        value: "blocks:manage",
        permissions: [
          { name: "Create Block", value: "blocks:create" },
          { name: "Update Block", value: "blocks:update" },
          { name: "Lock Block", value: "blocks:lock" },
          { name: "Unlock Block", value: "blocks:unlock" },
          {
            name: "Mark Block As Out of Use",
            value: "blocks:mark-as-out-of-use",
          }, // soft-delete.
        ],
      },
      {
        name: "Rounds",
        value: "rounds:manage",
        permissions: [
          { name: "Create Round", value: "rounds:create" },
          { name: "Update Round", value: "rounds:update" },
          { name: "Lock Round", value: "rounds:lock" },
          { name: "Unlock Round", value: "rounds:unlock" },
        ],
      },
      {
        name: "Plots",
        value: "plots:manage",
        permissions: [
          { name: "Create Plot", value: "plots:create" },
          { name: "Update Plot", value: "plots:update" },
          { name: "Lock Plot", value: "plots:lock" },
          { name: "Unlock Plot", value: "plots:unlock" },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Assign Geocode", value: "service-requests:assign-location" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "Update Location", value: "service-points:update-location" },
          { name: "Assign Location", value: "service-points:assign-location" },
          { name: "Initiate Transfer", value: "service-points:initiate-transfer" },
        ],
      },
      {
        name: "Mass Amendments",
        value: "service-point-amendments:manage",
        permissions: [
          { name: "Initiate Amendment", value: "geocode-amendments:initiate" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [
          {
            name: "Assign Geocode",
            value: "shep-regularizations:assign-location",
          },
        ],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [
          { name: "Assign Geocode", value: "regularizations:assign-location" },
        ],
      },
      {
        name: "No Trace Service Orders",
        value: "no-trace-service-orders:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "stores",
    name: "Store Management Console",
    description:
      "The Materials Management portal serves as the central platform for overseeing the management of meters and materials used by the Electricity Company of Ghana.",
    url: "https://stores.ecg.com.gh",
    icon: "ArchiveBoxIcon",
    iconForeground: "#167A8B",
    iconBackground: "#D5FBEC",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Meters",
        value: "meters:manage",
        permissions: [{ name: "Update Meter", value: "meters:update" }],
      },
      {
        name: "Meter Shipments",
        value: "meter-shipments:manage",
        permissions: [
          { name: "Create Shipment", value: "meter-shipments:create" },
        ],
      },
      {
        name: "MMS Meter Shipments",
        value: "mms-meter-shipments:manage",
        permissions: [
          { name: "Create Shipment", value: "mms-meter-shipments:create" },
        ],
      },
      {
        name: "Meter Transfers",
        value: "meter-transfers:manage",
        permissions: [
          { name: "Create Transfer", value: "meter-transfers:create" },
        ],
      },
      {
        name: "Meter Reversals",
        value: "meter-reversals:manage",
        permissions: [
          { name: "Create Reversal", value: "meter-reversals:create" },
        ],
      },
      {
        name: "Materials",
        value: "materials:manage",
        permissions: [
          { name: "Create Materials", value: "materials:create" },
          { name: "Update Materials", value: "materials:update" },
        ],
      },
      {
        name: "Meter Systems",
        value: "meter-systems:manage",
        permissions: [
          { name: "", value: "meter-systems:create" },
          { name: "", value: "meter-systems:update" },
        ],
      },
      {
        name: "Meter Brands",
        value: "meter-brands:manage",
        permissions: [
          { name: "", value: "meter-brands:create" },
          { name: "", value: "meter-brands:update" },
        ],
      },
      {
        name: "Meter Models",
        value: "meter-models:manage",
        permissions: [
          { name: "", value: "meter-models:create" },
          { name: "", value: "meter-models:update" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "technical",
    name: "Technical Services Console",
    description:
      "The Technical Services portal serves as the central system through which District Technical Officers of the Electricity Company of Ghana oversee and coordinate technical and field service interactions",
    url: "https://technical.ecg.com.gh",
    icon: "WrenchScrewdriverIcon",
    iconForeground: "#B71D29",
    iconBackground: "#FFE7D7",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Inspection Service Orders",
        value: "inspection-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "inspection-service-orders:assign" },
          { name: "Approve Order", value: "inspection-service-orders:approve" },
          {
            name: "Disapprove Order",
            value: "inspection-service-orders:disapprove",
          },
          { name: "Reset Order", value: "inspection-service-orders:reset" },
        ],
      },
      {
        name: "Regularization Inspection Service Orders",
        value: "regularization-inspection-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "regularization-inspection-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "regularization-inspection-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "regularization-inspection-service-orders:disapprove",
          },
        ],
      },
      {
        name: "Installation Service Orders",
        value: "installation-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "installation-service-orders:assign" },
          {
            name: "Approve Order",
            value: "installation-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "installation-service-orders:disapprove",
          },
          {
            name: "Escalate Order",
            value: "installation-service-orders:escalate",
          },
          { name: "Reset Order", value: "installation-service-orders:reset" },
        ],
      },
      {
        name: "Regularization Installation Service Orders",
        value: "regularization-installation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "regularization-installation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "regularization-installation-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "regularization-installation-service-orders:disapprove",
          },
          {
            name: "Reset Order",
            value: "regularization-installation-service-orders:reset",
          },
        ],
      },
      {
        name: "Backlog Installation Service Orders",
        value: "backlog-installation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "backlog-installation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "backlog-installation-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "backlog-installation-service-orders:disapprove",
          },
          {
            name: "Reset Order",
            value: "backlog-installation-service-orders:reset",
          },
        ],
      },
      {
        name: "Replacement Service Orders",
        value: "replacement-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "replacement-service-orders:initiate",
          },
          { name: "Assign Order", value: "replacement-service-orders:assign" },
          {
            name: "Approve Order",
            value: "replacement-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "replacement-service-orders:disapprove",
          },
          { name: "Cancel Order", value: "replacement-service-orders:cancel" },
          { name: "Reset Order", value: "replacement-service-orders:reset" },
        ],
      },
      {
        name: "Investigation Service Orders",
        value: "investigation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "investigation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "investigation-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "investigation-service-orders:disapprove",
          },
          {
            name: "Reset Order",
            value: "investigation-service-orders:reset",
          },
        ],
      },
      {
        name: "Meter Removal Service Orders",
        value: "termination-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "termination-service-orders:assign" },
          {
            name: "Approve Order",
            value: "termination-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "termination-service-orders:disapprove",
          },
        ],
      },
      {
        name: "Prepaid Monitoring Service Orders",
        value: "prepaid-monitoring-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "prepaid-monitoring-service-orders:initiate",
          },
          {
            name: "Assign Order",
            value: "prepaid-monitoring-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "prepaid-monitoring-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "prepaid-monitoring-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "prepaid-monitoring-service-orders:cancel",
          },
        ],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
      {
        name: "Discovery Service Orders",
        value: "discovery-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "discovery-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "discovery-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "discovery-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "discovery-service-orders:cancel",
          },
          {
            name: "Initiate Order",
            value: "discovery-service-orders:initiate",
          },
        ],
      },
      {
        name: "Customer Identification Service Orders",
        value: "customer-identification-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "customer-identification-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "customer-identification-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "customer-identification-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "customer-identification-service-orders:cancel",
          },
          {
            name: "Initiate Order",
            value: "customer-identification-service-orders:initiate",
          },
        ],
      },
      {
        name: "Solar PV Installation Service Orders",
        value: "solar-pv-installation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "solar-pv-installation-service-orders:assign",
          },

          {
            name: "Approve Order",
            value: "solar-pv-installation-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "solar-pv-installation-service-orders:disapprove",
          },
          {
            name: "Reset Order",
            value: "solar-pv-installation-service-orders:reset",
          },
        ],
      },
      {
        name: "Solar PV Inspection Service Orders",
        value: "solar-pv-inspection-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "solar-pv-inspection-service-orders:assign",
          },

          {
            name: "Approve Order",
            value: "solar-pv-inspection-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "solar-pv-inspection-service-orders:disapprove",
          },
          {
            name: "Reset Order",
            value: "solar-pv-inspection-service-orders:reset",
          },
        ],
      },
      {
        name: "Meter Reprogramming Service Orders",
        value: "meter-reprogramming-service-orders:manage",
        permissions: [
          {
            name: "Initiate Meter Reprogramming Service Order",
            value: "meter-reprogramming-service-orders:initiate",
          },
          {
            name: "Assign Meter Reprogramming Service Order",
            value: "meter-reprogramming-service-orders:assign",
          },
          {
            name: "Approve Meter Reprogramming Service Order",
            value: "meter-reprogramming-service-orders:approve",
          },
          {
            name: "Disapprove Meter Reprogramming Service Order",
            value: "meter-reprogramming-service-orders:disapprove",
          },
        ],
      },
      {
        name: "Street Lights",
        value: "street-lights:manage",
        permissions: [
          {
            name: "Update Streetlight",
            value: "street-lights:update",
          },
          {
            name: "Delete Streetlight",
            value: "street-lights:delete",
          },

        ],
      },
      {
        name: "Reading Audit Service Orders",
        value: "reading-audit-service-orders:manage",
        permissions: [
          {
            name: "Initiate Reading Audit Service Order",
            value: "reading-audit-service-orders:initiate",
          },
          {
            name: "Assign Reading Audit Service Order",
            value: "reading-audit-service-orders:assign",
          },
          {
            name: "Assign Reading Audit Service Order",
            value: "reading-audit-service-orders:resolve",
          },
          {
            name: "Approve Reading Audit Service Order",
            value: "reading-audit-service-orders:approve",
          },
          {
            name: "Disapprove Reading Audit Service Order",
            value: "reading-audit-service-orders:disapprove",
          },
        ],
      },

    ],
  },
  {
    code: "backlog",
    name: "Backlog Console",
    description:
      "The Backlog portal is designed to aid the Electricity Company of Ghana in the management and resolution of a wide range of pending tasks and issues, primarily associated with their operational backlog",
    url: "https://backlog.ecg.com.gh",
    icon: "ClockIcon",
    iconForeground: "#0D1E28",
    iconBackground: "#E8EBEC",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Paid-Up Backlogs",
        value: "backlog-service-order-initiations:manage",
        permissions: [
          {
            name: "Initiate Backlogs",
            value: "backlog-service-order-initiations:create",
          },
        ],
      },
      {
        name: "Shep & Service Backlogs",
        value: "service-backlogs:manage",
        permissions: [
          { name: "Initiate Backlogs", value: "service-backlogs:create" },
        ],
      },
      {
        name: "Invoice Waivers",
        value: "invoice-waivers:manage",
        permissions: [
          { name: "Initiate Waivers", value: "invoice-waivers:initiate" },
        ],
      },
      {
        name: "Service Point Reactivations",
        value: "service-point-reactivations:manage",
        permissions: [
          {
            name: "Initiate Reactivations",
            value: "service-point-reactivations:initiate",
          },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
          {
            name: "Update Attributes",
            value: "service-points:update-attributes",
          },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Update Contact", value: "service-requests:update-contact" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Data Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
    ],
  },
  {
    code: "zeus",
    name: "ZEUS Mobile",
    description: "Add description here",
    url: "mobile://commercial.ecg.com.gh",
    icon: "DevicePhoneMobileIcon",
    iconForeground: "#012A2F",
    iconBackground: "#C6F5E1",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Inspection Service Orders",
        value: "inspection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Regularization Inspection Service Orders",
        value: "regularization-inspection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Installation Service Orders",
        value: "installation-service-orders:manage",
        permissions: [],
      },
      {
        name: "Backlog Installation Service Orders",
        value: "backlog-installation-service-orders:manage",
        permissions: [],
      },
      {
        name: "Regularization Installation Service Orders",
        value: "regularization-installation-service-orders:manage",
        permissions: [],
      },
      {
        name: "Replacement Service Orders",
        value: "replacement-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "replacement-service-orders:initiate",
          },
        ],
      },
      {
        name: "Fault Service Orders",
        value: "fault-service-orders:manage",
        permissions: [],
      },
      {
        name: "Reconnection Service Orders",
        value: "reconnection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Disconnection Service Orders",
        value: "disconnection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Termination Service Orders",
        value: "termination-service-orders:manage",
        permissions: [],
      },
      {
        name: "Transformer Maintenance Service Orders",
        value: "transformer-maintenance-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "transformer-maintenance-service-orders:initiate",
          },
        ],
      },
    ],
  },
  // {
  //   code: "vulcan",
  //   name: "Vulcan Mobile",
  //   description: "Add description here",
  //   url: "mobile://commerical.ecg.com.gh",
  //   docs: "",
  //   icon: "ClockIcon",
  //   iconForeground: "#012A2F",
  //   iconBackground: "#C6F5E1",
  //   sections: [
  //     {
  //       name: "Stations",
  //       value: "stations:manage",
  //       permissions: [
  //         { name: "Create Primary Substation", value: "stations:create" },
  //         { name: "Update Primary Substation", value: "stations:update" },
  //         { name: "Import Primary Substation", value: "stations:import" },
  //         { name: "Delete Primary Substation", value: "stations:delete" },
  //       ],
  //     },
  //     {
  //       name: "Feeders",
  //       value: "feeders:manage",
  //       permissions: [
  //         { name: "Create Feeder", value: "feeders:create" },
  //         { name: "Update Feeder", value: "feeders:update" },
  //         { name: "Import Feeder", value: "feeders:import" },
  //         { name: "Delete Feeder", value: "feeders:delete" },
  //       ],
  //     },
  //     {
  //       name: "Bulk Supply Points",
  //       value: "bulk-supply-points:manage",
  //       permissions: [
  //         { name: "Create Bulk Supply Points", value: "bulk-supply-points:create" },
  //         { name: "Update Bulk Supply Points", value: "bulk-supply-points:update" },
  //         { name: "Import Bulk Supply Points", value: "bulk-supply-points:import" },
  //         { name: "Delete Bulk Supply Points", value: "bulk-supply-points:delete" },
  //       ],
  //     },
  //   ],
  // },
  {
    code: "finance",
    name: "Finance Management Console",
    description: "Console for viewing and managing jobs",
    url: "https://finance.subsenterprise.com/",
    icon: "CurrencyDollarIcon",
    iconForeground: "#550D9C",
    iconBackground: "#F7D0FD",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Job Listings",
        value: "service-request-subs:manage",
        permissions: [
          { name: "Resolve Job", value: "service-request-subs:resolve-job" },
        ],
      },
      {
        name: "Materials",
        value: "materials:manage",
        permissions: [
          { name: "Update Pricing", value: "materials:update-price" },
        ],
      },
      {
        name: "Quotations",
        value: "installation-types:manage",
        permissions: [
          { name: "Update Pricing", value: "installation-types:update-price" },
          {
            name: "Update Materials",
            value: "installation-types:update-materials",
          },
        ],
      },
      {
        name: "Revenue Protection Configs",
        value: "revenue-protection:manage",
        permissions: [
          {
            name: "Create Revenue Protection",
            value: "revenue-protection:create",
          },
          {
            name: "Update Revenue Protection",
            value: "revenue-protection:update",
          },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "mis",
    name: "MIS Console",
    description: "Console for viewing and managing jobs",
    url: "https://mis.subsenterprise.com/",
    iconForeground: "#0C4336",
    iconBackground: "#D2F6D7",
    icon: "ChartBarIcon",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Approve Request", value: "service-requests:approve" },
          { name: "Sign Contract", value: "service-requests:sign-contract" },
          { name: "Update Contact", value: "service-requests:update-contact" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Mass Amendments",
        value: "service-point-amendments:manage",
        permissions: [
          { name: "Initiate Amendment", value: "geocode-amendments:initiate" },
        ],
      },
      {
        name: "Regions",
        value: "regions:manage",
        permissions: [
          { name: "Create Region", value: "regions:create" },
          { name: "Update Region", value: "regions:update" },
        ],
      },
      {
        name: "Districts",
        value: "districts:manage",
        permissions: [
          { name: "Create District", value: "districts:create" },
          { name: "Update District", value: "districts:update" },
        ],
      },
      {
        name: "Blocks",
        value: "blocks:manage",
        permissions: [
          { name: "Create Block", value: "blocks:create" },
          { name: "Update Block", value: "blocks:update" },
          { name: "Lock Block", value: "blocks:lock" },
          { name: "Unlock Block", value: "blocks:unlock" },
        ],
      },
      {
        name: "Rounds",
        value: "rounds:manage",
        permissions: [
          { name: "Create Round", value: "rounds:create" },
          { name: "Update Round", value: "rounds:update" },
          { name: "Lock Round", value: "rounds:lock" },
          { name: "Unlock Round", value: "rounds:unlock" },
        ],
      },
      {
        name: "Plots",
        value: "plots:manage",
        permissions: [
          { name: "Create Plot", value: "plots:create" },
          { name: "Update Plot", value: "plots:update" },
          { name: "Lock Plot", value: "plots:lock" },
          { name: "Unlock Plot", value: "plots:unlock" },
        ],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
          {
            name: "Initiate Investigation",
            value: "complaints:initiate-investigation",
          },
          {
            name: "Initiate Disconnection",
            value: "complaints:initiate-disconnection",
          },
          {
            name: "Initiate Reconnection",
            value: "complaints:initiate-reconnection",
          },
          {
            name: "Initiate Termination",
            value: "complaints:initiate-termination",
          },
        ],
      },
    ],
  },
  {
    code: "engineer",
    name: "Engineer Services Console",
    description:
      "The Engineer Services portal serves as the central system through which District Technical Officers of the Electricity Company of Ghana oversee and coordinate technical and field service interactions",
    url: "https://engineer.ecg.com.gh",
    icon: "WrenchIcon",
    iconForeground: "#B7491D",
    iconBackground: "#FFF0D7",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
        ],
      },
      {
        name: "Shep Regularizations",
        value: "shep-regularizations:manage",
        permissions: [],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Fault Service Orders",
        value: "fault-service-orders:manage",
        permissions: [
          { name: "Assign Order", value: "fault-service-orders:assign" },
          { name: "Approve Order", value: "fault-service-orders:approve" },
          {
            name: "Disapprove Order",
            value: "fault-service-orders:disapprove",
          },
        ],
      },
      {
        name: "Transformer Maintenance Service Orders",
        value: "transformer-maintenance-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "transformer-maintenance-service-orders:initiate",
          },
          {
            name: "Assign Order",
            value: "transformer-maintenance-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "transformer-maintenance-service-orders:approve",
          },
          {
            name: "Reset Order",
            value: "transformer-maintenance-service-orders:reset",
          },
          {
            name: "Cancel Order",
            value: "transformer-maintenance-service-orders:cancel",
          },
        ],
      },
      {
        name: "Transformer Installation Service Orders",
        value: "transformer-installation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "transformer-installation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "transformer-installation-service-orders:approve",
          },
          {
            name: "Reset Order",
            value: "transformer-installation-service-orders:reset",
          },
        ],
      },
      {
        name: "Boundary Installation Service Orders",
        value: "boundary-installation-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "boundary-installation-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "boundary-installation-service-orders:approve",
          },
          {
            name: "Reset Order",
            value: "boundary-installation-service-orders:reset",
          },
        ],
      },
      {
        name: "Transformer Replacement Service Orders",
        value: "transformer-replacement-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "transformer-replacement-service-orders:initiate",
          },
          {
            name: "Assign Order",
            value: "transformer-replacement-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "transformer-replacement-service-orders:approve",
          },
          {
            name: "Cancel Order",
            value: "transformer-replacement-service-orders:cancel",
          },
          {
            name: "Reset Order",
            value: "transformer-replacement-service-orders:reset",
          },
        ],
      },
      {
        name: "Boundary Replacement Service Orders",
        value: "boundary-replacement-service-orders:manage",
        permissions: [
          {
            name: "Initiate Order",
            value: "boundary-replacement-service-orders:initiate",
          },
          {
            name: "Assign Order",
            value: "boundary-replacement-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "boundary-replacement-service-orders:approve",
          },
          {
            name: "Cancel Order",
            value: "boundary-replacement-service-orders:cancel",
          },
          {
            name: "Reset Order",
            value: "boundary-replacement-service-orders:reset",
          },
        ],
      },
      {
        name: "Network Analysis Service Orders",
        value: "network-analysis-service-orders:manage",
        permissions: [
          {
            name: "Complete Order",
            value: "network-analysis-service-orders:complete",
          },

        ],
      },
      {
        name: "Feeders",
        value: "feeders:manage",
        permissions: [
          {
            name: "Create Feeders",
            value: "feeders:create",
          },
          {
            name: "Update Feeders",
            value: "feeders:update",
          },
          {
            name: "Import Feeders",
            value: "feeders:import",
          },
          {
            name: "Delete Feeders",
            value: "feeders:delete",
          },
        ],
      },
      {
        name: "Stations",
        value: "stations:manage",
        permissions: [
          {
            name: "Create Stations",
            value: "stations:create",
          },
          {
            name: "Update Stations",
            value: "stations:update",
          },
          {
            name: "Import Stations",
            value: "stations:import",
          },
          {
            name: "Delete Stations",
            value: "stations:delete",
          },
        ],
      },
      {
        name: "Bulk Supply Points",
        value: "bulk-supply-points:manage",
        permissions: [
          {
            name: "Create Bulk Supply Points",
            value: "bulk-supply-points:create",
          },
          {
            name: "Update Bulk Supply Points",
            value: "bulk-supply-points:update",
          },
          {
            name: "Import Bulk Supply Points",
            value: "bulk-supply-points:import",
          },
          {
            name: "Delete Bulk Supply Points",
            value: "bulk-supply-points:delete",
          },
        ],
      },
      {
        name: "Feeder Boundaries",
        value: "feeder-boundaries:manage",
        permissions: [
          { name: "Create Feeder Boundary", value: "feeder-boundaries:create" },
          { name: "Update Feeder Boundary", value: "feeder-boundaries:update" },
          { name: "Import Feeder Boundary", value: "feeder-boundaries:import" },
          { name: "Delete Feeder Boundary", value: "feeder-boundaries:delete" },
        ],
      },
      {
        name: "Transformers",
        value: "transformers:manage",
        permissions: [
          { name: "Create Transformer", value: "transformers:create" },
          { name: "Update Transformer", value: "transformers:update" },
          { name: "Import Transformer", value: "transformers:import" },
          { name: "Delete Transformer", value: "transformers:delete" },
        ],
      },
      {
        name: "Transformer Makes",
        value: "transformer-makes:manage",
        permissions: [
          {
            name: "Create Transformer Make",
            value: "transformer-makes:create",
          },
          {
            name: "Update Transformer Make",
            value: "transformer-makes:update",
          },
          {
            name: "Import Transformer Make",
            value: "transformer-makes:import",
          },
          {
            name: "Delete Transformer Make",
            value: "transformer-makes:delete",
          },
        ],
      },

      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Initiate Fault", value: "complaints:initiate-fault" },
          {
            name: "Initiate Transformer Maintenance",
            value: "complaints:initiate-transformer-maintenance",
          },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
    ],
  },
  {
    code: "support",
    name: "Customer Support Console",
    description:
      "The Customer Support Console serves as the central platform for complaints and issue-tracking used by the Electricity Company of Ghana.",
    url: "https://support.ecg.com.gh",
    icon: "ChatBubbleLeftRightIcon",
    iconForeground: "#B742B7",
    iconBackground: "#FFE6F1",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
        ],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "ppme",
    name: "PPME Console",
    description: "The PPME console used by the Electricity Company of Ghana.",
    url: "https://ppme.ecg.com.gh",
    icon: "BuildingOfficeIcon",
    iconForeground: "#012A2F",
    iconBackground: "#C6F5E1",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
        ],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [
          { name: "Create Regularization", value: "regularizations:create" },
          { name: "Import Regularization", value: "regularizations:import" },
        ],
      },
      {
        name: "Installation Monitoring Service Orders",
        value: "installation-monitoring-service-orders:manage",
        permissions: [
          {
            name: "Assign Order",
            value: "installation-monitoring-service-orders:assign",
          },
          {
            name: "Approve Order",
            value: "installation-monitoring-service-orders:approve",
          },
          {
            name: "Cancel Order",
            value: "installation-monitoring-service-orders:cancel",
          },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
      {
        name: "Complaints",
        value: "complaints:manage",
        permissions: [],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [],
      },
    ],
  },
  {
    code: "ips",
    name: "IPS Console",
    description: "The IPS console used by the Electricity Company of Ghana.",
    url: "https://ips.ecg.com.gh",
    icon: "BuildingOffice2Icon",
    iconForeground: "#0C4336",
    iconBackground: "#D2F6D7",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
          { name: "View Readings", value: "service-points:view-readings" },
          { name: "View Updates", value: "service-points:view-updates" },
          {
            name: "Update Contact",
            value: "service-points:update-contact",
          },
          { name: "Update Location", value: "service-points:update-location" },
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [
          { name: "Approve Request", value: "service-requests:approve" },
          { name: "Sign Contract", value: "service-requests:sign-contract" },
          { name: "Update Contact", value: "service-requests:update-contact" },
        ],
      },
      {
        name: "Service Regularizations",
        value: "regularizations:manage",
        permissions: [],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
          {
            name: "Initiate Investigation",
            value: "complaints:initiate-investigation",
          },
          {
            name: "Initiate Disconnection",
            value: "complaints:initiate-disconnection",
          },
          {
            name: "Initiate Reconnection",
            value: "complaints:initiate-reconnection",
          },
          {
            name: "Initiate Termination",
            value: "complaints:initiate-termination",
          },
        ],
      },
      {
        name: "Illegality Confirmation Service Orders",
        value: "illegality-confirmation-service-orders:manage",
        permissions: [
          {
            name: "Create Order",
            value: "illegality-confirmation-service-orders:create",
          },
          {
            name: "Update Order",
            value: "illegality-confirmation-service-orders:update",
          },
          {
            name: "Assign Order",
            value: "illegality-confirmation-service-orders:assign",
          },
          {
            name: "Send Illegal Notice",
            value: "illegality-confirmation-service-orders:send-illegal-notice",
          },
          {
            name: "Approve Order",
            value: "illegality-confirmation-service-orders:approve",
          },
          {
            name: "Disapprove Order",
            value: "illegality-confirmation-service-orders:disapprove",
          },
          {
            name: "Cancel Order",
            value: "illegality-confirmation-service-orders:cancel",
          },
          {
            name: "Attach Service Request",
            value:
              "illegality-confirmation-service-orders:attach-service-request",
          },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
      {
        name: "Administrative Fees",
        value: "illegality-administrative-fees:manage",
        permissions: [],
      },
      {
        name: "Non-Energy Surcharges",
        value: "illegality-non-energy-surcharges:manage",
        permissions: [],
      },
      {
        name: "Recovery Bills",
        value: "recovery-bills:manage",
        permissions: [
          { name: "Create Bill", value: "recovery-bills:create" },
          { name: "Schedule Bill", value: "recovery-bills:schedule" },
          { name: "Cancel Bill", value: "recovery-bills:cancel" },
        ],
      },
      {
        // name: "Top Debtors", // renamed for IPS.
        name: "Debtors Sets",
        value: "top-debtors:manage",
        permissions: [
          { name: "Assign Team", value: "top-debtors:assign-team" },
        ],
      },
    ],
  },
  {
    code: "scrapyard",
    name: "Scrap Yard Console",
    description: "Console for scrap yard to sort out retired meters",
    url: "",
    icon: "ArchiveBoxIcon",
    iconForeground: "#304ED5",
    iconBackground: "#D5DFFC",
    sections: [
      {
        name: "Meter Retirment Sets",
        value: "meter-retirement-sets:manage",
        permissions: [
          {
            name: "Start Meter Retirement Set",
            value: "meter-retirement-sets:start",
          },
          { name: "Complete", value: "meter-retirement-sets:complete" },
        ],
      },
    ],
  },
  {
    code: "analytics",
    name: "Analytics Console",
    description:
      "The Business Analytics console provides District Managers  of the Electricity Company of Ghana with statistics and insights on the daily or  periodic engagements between their districts and customers. It allows them to monitor all operations within the various departments of the district.",
    url: "https://analytics.ecg.com.gh",
    icon: "ChartBarSquareIcon",
    iconForeground: "#9546BD",
    iconBackground: "#F9DCFB",
    sections: [
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
          { name: "View Tickets", value: "service-points:view-tickets" },
        ],
      },
    ],
  },
  {
    code: "lrp",
    name: "LRP Console",
    description:
      "The Loss Reduction Program console of the Electricity Company of Ghana.",
    url: "https://lrp.ecg.com.gh",
    icon: "DocumentArrowDownIcon",
    iconForeground: "#009689",
    iconBackground: "#CBFBF1",
    sections: [
      {
        name: "Support",
        value: "support:manage",
        permissions: [
          { name: "Create Issue", value: "issues:create" },
          { name: "Update Issue", value: "issues:update" },
          { name: "Approve Issue", value: "issues:approve" },
          { name: "Escalate Issue", value: "issues:escalate" },
          { name: "Refer Issue", value: "issues:refer" },
          { name: "Reject Issue", value: "issues:reject" },
          { name: "Resolve Issue", value: "issues:resolve" },
        ],
      },
      {
        name: "Tickets",
        value: "complaints:manage",
        permissions: [
          { name: "Create Ticket", value: "complaints:create" },
        ],
      },
      {
        name: "Service Points",
        value: "service-points:manage",
        permissions: [
        ],
      },
      {
        name: "Service Requests",
        value: "service-requests:manage",
        permissions: [],
      },
      {
        name: "Inspection Service Orders",
        value: "inspection-service-orders:manage",
        permissions: [],
      },
      {
        name: "Installation Service Orders",
        value: "installation-service-orders:manage",
        permissions: [],
      },
      {
        name: "Replacement Service Orders",
        value: "replacement-service-orders:manage",
        permissions: [],
      },
      {
        name: "Meter Delivery Request",
        value: "meter-delivery-requests:manage",
        permissions: [
          {
            name: "Confirm Request",
            value: "meter-delivery-requests:confirm",
          },
          {
            name: "Reject Request",
            value: "meter-delivery-requests:reject",
          },
          {
            name: "Process Invoice Payment",
            value: "meter-delivery-requests:process-payment",
          },
        ],
      },
      {
        name: "Factory Acceptance Test Service Orders",
        value: "factory-acceptance-test-service-orders:manage",
        permissions: [
          {
            name: "Assign Factory Acceptance Test Service Order",
            value: "factory-acceptance-test-service-orders:assign",
          },
          {
            name: "Resolve Factory Acceptance Test Service Order",
            value: "factory-acceptance-test-service-orders:resolve",
          },
          {
            name: "Approve Factory Acceptance Test Service Order",
            value: "factory-acceptance-test-service-orders:approve",
          },
          {
            name: "Disapprove Factory Acceptance Test Service Order",
            value: "factory-acceptance-test-service-orders:disapprove",
          },
        ],
      },
      {
        name: "Service Order Exports",
        value: "service-order-exports:manage",
        permissions: [
          { name: "Cancel Export", value: "service-order-exports:cancel" },
        ],
      },
    ],
  }
];

export const ApplicationsMap = lodash.keyBy(Applications, "code");

export type Application = (typeof Applications)[number]["code"];
